module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeholder":"Please leave a comment","submit":"Submit","cancel":"Cancel","create_comment_failure":"An error occurred while posting the comment.","edit_comment_failure":"An error occurred while editing the comment.","confirm_cancel_edit":"Are you sure you want to cancel the comment modification?"}}')
  delete Component.options._Ctor
}
